import Tooltip from '../Tooltip/Tooltip';
import { ReactComponent as InformationIcon } from '../../../assets/icons/aml/information.svg';
import React from "react";
import "../../../css/DesignSystem/Inputs/NewTextArea.css";

const NewTextArea = ({
  id,
  name,
  inputProps = {},
  label,
  tooltip,
  value,
  onChange,
  placeholder,
  required = false,
  helperText,
  error,
  disabled = false,
  readOnly = false,
  maxLength = 300,
  className = "",
}) => {
  const count = value?.length || 0;

  return (
    <div className={`AnnouncementTextArea fit-column gap-xs ${className}`.trim()}>
      {label && (
        <label
          htmlFor={id}
          className="AnnouncementTextArea__Label FP_Content text-black"
        >
          {label} {required && <span className="FP_Content_Semibold text-error">*</span>}
        {tooltip && <Tooltip content={tooltip} position="top"><InformationIcon className="ds-portal-input-tooltip-icon" aria-label={typeof label === 'string' ? label + ' help' : 'Field help'} /></Tooltip>}
        </label>
      )}

      {helperText && (
        <p id={!error ? `${id}-message` : undefined} className="AnnouncementTextArea__Helper FP_Content text-black">{helperText}</p>
      )}

      <div className="AnnouncementTextArea__Wrapper">
        <textarea
          {...inputProps}
          name={name || id}
          required={required}
          aria-invalid={!!error}
          aria-describedby={error || helperText ? `${id}-message` : undefined}
          id={id}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          disabled={disabled}
          readOnly={readOnly}
          maxLength={maxLength}
          className={`fp-form-input fp-form-textarea FP_Content announcement-content-textarea ${
            error ? "fp-form-input--error" : ""
          }`}
        />

        <span className="AnnouncementTextArea__Count FP_Help_Text ">
          {count}/{maxLength} characters
        </span>
      </div>

      {error && <p id={`${id}-message`} className="AnnouncementTextArea__Error FP_Content text-error">{error}</p>}
    </div>
  );
};

export default NewTextArea;
